export default {
  data() {
    return {
      allMissionOtherOrganizationRequests: [],
    };
  },
  methods: {
    getAllMissionOtherOrganizationRequestsFor800TopListFunction: function (missionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllMissionOtherOrganizationRequestsByMissionId', missionId)
        .then(() => {
          if (this.$store.state.missionOtherOrganizationRequestModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.allMissionOtherOrganizationRequests =
              this.$store.state.missionOtherOrganizationRequestModule.allMissionOtherOrganizationRequests;
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionOtherOrganizationRequestModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.missionOtherOrganizationRequestModule.successFlag) {
                  this.getAllMissionOtherOrganizationRequestsFor800TopListFunction(missionId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionOtherOrganizationRequestModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllMissionOtherOrganizationRequestsFor800TopListFunction(missionId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    showError: function () {
      this.snackText = this.$store.state.missionOtherOrganizationRequestModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
